import { ApiError } from '../api/api-error';

const TECH_PATTERNS = [
  /conn\s*busy/i,
  /ECONNREFUSED/i,
  /ENOTFOUND/i,
  /JSON\s*parse/i,
  /SyntaxError/i,
  /Unexpected\s+token/i,
  /\{\s*"detail"\s*:/,
  /<\s*html/i,
  /Traceback/i,
  /\bat\s+[\w.]+\s*\(/i,
  /^HTTP\s+\d{3}\s*$/i,
  /Failed to fetch/i,
  /NetworkError/i,
  /Load failed/i,
  /internal server error/i,
  /SQLSTATE/i,
  /violates\s+(not-null|foreign key|unique)\s+constraint/i,
  /null value in column/i,
  /duplicate key value/i,
  /insert\s+or\s+update\s+on\s+table/i,
  /\bpgx\b/i
];

const ACTION_FALLBACK = 'Не удалось выполнить действие';
const LOAD_FALLBACK = 'Не удалось загрузить данные';

/** Сообщения, которые нельзя показывать пользователю как есть. */
export function isLikelyTechnicalUserMessage(text: string): boolean {
  const t = text.trim();
  if (!t) return true;
  if (t.length > 500) return true;
  return TECH_PATTERNS.some((re) => re.test(t));
}

function userFacingMessageWithFallback(err: unknown, fallback: string): string {
  let msg = '';
  if (err instanceof ApiError) {
    msg = (err.detail ?? '').trim();
  } else if (err instanceof Error) {
    msg = err.message.trim();
  } else {
    msg = String(err ?? '').trim();
  }

  if (!msg || isLikelyTechnicalUserMessage(msg)) return fallback;

  return stripLeadValidationPrefix(msg);
}

/**
 * Срезает сервисный префикс «validation:» с текста нарушения
 * (SlotMoveViolation.Msg / detail API) — префикс не для пользователя.
 */
export function stripLeadValidationPrefix(text: string): string {
  const msg = text.trim();
  const prefix = 'validation:';
  if (msg.toLowerCase().startsWith(prefix)) {
    return msg.substring(prefix.length).trim();
  }
  return msg;
}

/**
 * Текст для тоста/общего сбоя действия: без сырого JSON, stack, HTML, техно-строк.
 * Если смысл не удаётся извлечь — общая формулировка.
 */
export function userFacingActionError(err: unknown): string {
  return userFacingMessageWithFallback(err, ACTION_FALLBACK);
}

/**
 * Текст для тоста при сбое загрузки списка/страницы/снимка.
 */
export function userFacingLoadError(err: unknown): string {
  return userFacingMessageWithFallback(err, LOAD_FALLBACK);
}
